import { render } from "./GroupBoard.vue?vue&type=template&id=10273015"
import script from "./GroupBoard.vue?vue&type=script&lang=js"
export * from "./GroupBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__